import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster as ShadcnToaster } from "@/components/ui/toaster";
import MechanicLayout from "@/mechanic/components/MechanicLayout";
import Dashboard from "@/mechanic/pages/Dashboard";
import RentalFleet from "@/mechanic/pages/RentalFleet";
import DealershipCars from "@/mechanic/pages/DealershipCars";
import WorkOrders from "@/mechanic/pages/WorkOrders";
import Customers from "@/mechanic/pages/Customers";
import Mechanics from "@/mechanic/pages/Mechanics";
import VehicleServicePage from "@/mechanic/pages/VehicleServicePage";
import Invoices from "@/mechanic/pages/Invoices";
import Inventory from "@/mechanic/pages/Inventory";
import Expenses from "@/mechanic/pages/Expenses";
import Suppliers from "@/mechanic/pages/Suppliers";
import ShopView from "@/mechanic/pages/ShopView";
import Financials from "@/mechanic/pages/Financials";
import ShopSettings from "@/mechanic/pages/ShopSettings";
import CannedJobs from "@/mechanic/pages/CannedJobs";
import CustomerDetail from "@/mechanic/pages/CustomerDetail";
import SupplierDetail from "@/mechanic/pages/SupplierDetail";
import WorkOrderDetail from "@/mechanic/pages/WorkOrderDetail";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

export default function MechanicApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route element={<MechanicLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="rental-fleet" element={<RentalFleet />} />
          <Route path="dealership-cars" element={<DealershipCars />} />
          <Route path="work-orders" element={<WorkOrders />} />
          <Route path="work-orders/:woId" element={<WorkOrderDetail />} />
          <Route path="shop-view" element={<ShopView />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="expenses" element={<Expenses />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="suppliers/:supplierId" element={<SupplierDetail />} />
          <Route path="financials" element={<Financials />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/:customerId" element={<CustomerDetail />} />
          <Route path="mechanics" element={<Mechanics />} />
          <Route path="canned-jobs" element={<CannedJobs />} />
          <Route path="settings" element={<ShopSettings />} />
          <Route path="vehicle/:source/:refId" element={<VehicleServicePage />} />
          <Route path="*" element={<Navigate to="/mechanic" replace />} />
        </Route>
      </Routes>
      <ShadcnToaster />
    </QueryClientProvider>
  );
}
